export default __webpack_public_path__ + "static/will-you-buy-christmas-tree-9b12cf9e3eefed90d000bf3a764350a2.png";